namespace GeniuzPOS.InitialData {
    export class PsExchangeRateColumns {
        static columnsKey = 'InitialData.PsExchangeRate';
    }
}
